import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  button {
    background-color: #102a63;
    color: #fff;
    font-size: 14px;
  }

  h4 {
    color: #102a63;
  }
`;

export const Section = styled.div`
  padding-top: 10px;

  h4 {
    color: #102a63;
    font-weight: bold;
  }

  .tab{
        color: #102961;
        cursor: pointer;

        .tab-header {
            display: flex;
            min-height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            text-decoration: uppercase;
            font-weight: bold;

            span{
                opacity: 0.5
            }
        }
        
        .tab-bar{
            background: #FFFFFFFF 0% 0% no-repeat padding-box;
            border-radius: 8px 8px 0 0;
            height: 4px;
        }

        &:hover{
            span{
                color: #102a63;
                opacity: 1!important;
            }

            .tab-bar{
                background: #102a63 0% 0% no-repeat padding-box;
                border-radius: 8px 8px 0 0;
                height: 4px;

                animation: zoomIn;
                animation-duration: 1s;
            }
        }
    }

    .tab-active {
        span{
            color: #102a63;
            opacity: 1!important;
        }

        .tab-bar{
            background: #102a63 0% 0% no-repeat padding-box;
            border-radius: 8px 8px 0 0;
        }
    }

    h2 {
        font-weight: bold !important;
        font-size: 22px;
        display: flex;
        
        .icon-left {
            cursor: pointer;
            background-color:#B0B0BB; 
            border-radius: 50%; 
            width: 35px; 
            height: 35px; 
            opacity: 0.5; 
            margin-right: 10px;
            padding: 5px;
    
            &:hover{
                opacity: 1;
                animation: pulse;
                animation-duration: 1s;
            }
        }
      }

  .grid-header {
    border-radius: 6px 6px 0 0; 
    background-color: #102a63;
    color: #fff;
  }

  .grid-header span {
    font-size: 16px;
    padding: 10px;
    font-weight: 900;
  }

  .border-div {
    width: 100%;
    border: 1px solid #000;
  }
  
  .upload-btn-wrapper {
      position: relative;
      overflow: hidden;
      display: inline-block;
  }

  .upload-btn-wrapper input[type=file] {
      font-size: 100px;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
  }

  .bs-wizard {margin-top: 40px;}

  /*Form Wizard*/
  .bs-wizard { padding: 0 0 10px 0;}
  .bs-wizard > .bs-wizard-step {padding: 0; position: relative;}
  .bs-wizard > .bs-wizard-step + .bs-wizard-step {}
  .bs-wizard > .bs-wizard-step .bs-wizard-stepnum {color: #595959; font-size: 16px; margin-bottom: 5px;}
  .bs-wizard > .bs-wizard-step .bs-wizard-info {color: #999; font-size: 14px;}
  .bs-wizard > .bs-wizard-step > .bs-wizard-dot {position: absolute; width: 30px; height: 30px; display: block; background: #767e8f; top: 45px; left: 50%; margin-top: -15px; margin-left: -15px; border-radius: 50%;} 
  .bs-wizard > .bs-wizard-step > .bs-wizard-dot:after {content: ' '; width: 14px; height: 14px; background: #102a63; border-radius: 50px; position: absolute; top: 8px; left: 8px; } 
  .bs-wizard > .bs-wizard-step > .progress {position: relative; border-radius: 0px; height: 8px; box-shadow: none; margin: 20px 0;}
  .bs-wizard > .bs-wizard-step > .progress > .progress-bar {width:0px; box-shadow: none; background: #767e8f;}
  .bs-wizard > .bs-wizard-step.complete > .progress > .progress-bar {width:100%;}
  .bs-wizard > .bs-wizard-step.active > .progress > .progress-bar {width:50%;}
  .bs-wizard > .bs-wizard-step:first-child.active > .progress > .progress-bar {width:0%;}
  .bs-wizard > .bs-wizard-step:last-child.active > .progress > .progress-bar {width: 100%;}
  .bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot {background-color: #f5f5f5;}
  .bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot:after {opacity: 0;}
  .bs-wizard > .bs-wizard-step:first-child  > .progress {left: 50%; width: 50%;}
  .bs-wizard > .bs-wizard-step:last-child  > .progress {width: 50%;}
  .bs-wizard > .bs-wizard-step.disabled a.bs-wizard-dot{ pointer-events: none; }

  .read-only-total,
  input,
  select,
  textarea {
    color: #000;
    flex: 1;
    padding: 0.375rem 0.75rem;
    height: 35px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    border: 1px solid #ced4da !important;
    border-radius: 6px;
    width: 100%;
    animation: flipInX;
    animation-duration: 1s;

    ${props =>
    props.isErrored &&
    css`
        border-color: #ff0000;
      `}
    ${props =>
    props.isFilled &&
    css`
        color: #333333;
      `}
    
        &::placeholder {
      color: #e2e2e2;
    }

    &:focus {
      box-shadow: 0;
    }

    &:active {
      box-shadow: 0;
    }

    &:focus-visible {
      box-shadow: 0;
      outline: none;
    }

    &:disabled {
      background-color: #e9ecef;
    }

    option {
      background-color: #ffffff;
    }
  }
`;

export const HeaderTable = styled.div`
  background-color: #ececf3;
  height: 44px;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  animation: flipInX;
  animation-duration: 1s;

  label {
    color: #102a63;
    font-weight: bold;
    font-size: 12px;
  }
`;

export const HeaderData = styled.div`
  background-color: #D9F3D7;
  height: 35px;
  border-radius: 6px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  animation: flipInX;
  animation-duration: 1s;

  input {
    border-radius: 6px !important;
  }
  
  label {
    color: #000;
    font-weight: bold;
    font-size: 12px;
  }
`;

export const FooterTable = styled.div`
  background-color: #102a63;
  height: 35px;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  animation: flipInX;
  animation-duration: 1s;

  label {
    color: #fff;
    font-weight: bold;
  }
`;

export const DivLeftButtons = styled.div`
  display: flex;
  width: 50%;
  justify-content: flex-start;
  align-items: center;

  button {
    background-color: #102a63;
    color: #fff;
    font-size: 14px;
  }
`;

export const DivRightButtons = styled.div`
  display: flex;
  width: 50%;
  justify-content: flex-end;
  align-items: center;

  button {
    background-color: #102a63;
    color: #fff;
    font-size: 14px;
  }
`;

